export default [
  {
    path: '/admin/sim-distributes',
    name: 'sim-distribute',
    meta: { requiresAuth: true },
    component: () => import('@/pages/sale/sim-distribute/index.vue')
  }
]
